// JsFromRoutes CacheKey 7c2bc5b50140d08bc21940eb33e0b5f2
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  import: /* #__PURE__ */ definePathHelper('post', '/:account_id/help/redirects/import'),
  export: /* #__PURE__ */ definePathHelper('get', '/:account_id/help/redirects/export'),
  index: /* #__PURE__ */ definePathHelper('get', '/:account_id/help/redirects'),
}
